<div class="wrap-x flex flex-column-s feature-banner animation-long"
     [class.flex-reverse]="component.reverse === 'right'"
     [class.animation-reveal]="canAnimate()"
     [gsap]
     [gsapOff]="client.isCms || !component.animation"
     [scrollTrigger]="{
       start: '50% bottom', end: '100% top', toggleClass: 'is-animate', once: true
    }">
    <!-- Full-size Image -->
    <div class="w-6 w-12-s"
         [ngClass]="component.component_ratio">
        <href [hrefClass]="'rf'"
              [link]="component.full_s_link">
            <div class="rf overflow-hidden"
                 [ngClass]="[component.padding === 'no_padding'? '' : ((component.reverse === 'right') ? 'm-l-1' : ' ')]">
                @if (component.full_s_video_id && !component.full_s_image) {
                <shell />
                }
                @if (component.full_s_image) {
                <img class="z-2 animation-zoom-in animation-on-hover"
                     [dfImage]="component.full_s_image"
                     [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                     [ratio]="component.component_ratio"
                     [alt]="component.full_s_image.alt"
                     fill>
                }
                @if (component.full_s_video_id) {
                <local-vimeo-player class="rf z-3 bg-col-w"
                                    [video-id]="component.full_s_video_id"
                                    [autoplay-in-viewport]="component.full_s_video_autoplay"
                                    [background]="component.full_s_video_background" />
                }
            </div>
            <!-- button -->
            @if (component.full_s_button_label) {
            <div class="pos-absolute bottom-2 left-3 z-4">
                <button class="button-inline has-icon"
                        type="button">
                    <span *iCms="'full_s_button_label' of component"></span>
                </button>
            </div>
            }
        </href>
    </div>

    <!-- Gallery Images -->
    <div class="w-6 w-12-s"
         [ngClass]="!client.isS ? component.component_ratio : ''">
        <div [sizeClass]="'XLM: fill flex overflow-hidden'">
            <div class="w-12">
                <href [link]="component.link_1">
                    <!-- Gallery Image 1 -->
                    <div class="_ratio"
                         [ngClass]="[shareColumnsTop(component), component.component_ratio]"
                         [style.height.%]="50">
                        <div class="rf overflow-hidden"
                             [ngClass]="[!client.isS ? component.padding === 'no_padding' ? '' : component.reverse === 'right' ? '' : ' m-l-1' : '']">
                            @if (component.video_id_1 && !component.image_1) {
                            <shell />
                            }
                            @if (component.image_1) {
                            <img class="z-2 animation-zoom-in animation-on-hover"
                                 [dfImage]="component.image_1"
                                 [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                                 [ratio]="component.component_ratio"
                                 [alt]="component.image_1.button_label_1"
                                 fill>
                            }
                            @if (component.video_id_1) {
                            <local-vimeo-player class="rf z-3 bg-col-w"
                                                [video-id]="component.video_id_1"
                                                [autoplay-in-viewport]="component.video_autoplay_1"
                                                [background]="component.video_background_1" />
                            }
                        </div>

                        <!-- button -->
                        @if (component.button_label_1) {
                        <div class="pos-absolute bottom-2 left-3 z-4">
                            <button class="button-inline has-icon"
                                    type="button">
                                <span *iCms="'button_label_1' of component"></span>
                            </button>
                        </div>
                        }
                    </div>
                </href>
                <!-- Gallery Image 2 -->
                @if (show2ndImg(component)) {
                <href [link]="component.link_2">
                    <div class="w-6 w-12-s _ratio"
                         [ngClass]="component.component_ratio"
                         [style.height.%]="50">
                        <div class="rf overflow-hidden"
                             [ngClass]="[!client.isS ? component.padding === 'no_padding'? '' : component.reverse === 'right' ? ' m-l-1' : ' m-l-2' : '']">
                            @if (component.video_id_2 && !component.image_2) {
                            <shell />
                            }
                            @if (component.image_2) {
                            <img class="z-2 animation-zoom-in animation-on-hover"
                                 [dfImage]="component.image_2"
                                 [ratio]="component.component_ratio"
                                 [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                                 [alt]="component.image_2.button_label_2"
                                 fill>
                            }
                            @if (component.video_id_2) {
                            <local-vimeo-player class="rf z-3 bg-col-w"
                                                [video-id]="component.video_id_2"
                                                [autoplay-in-viewport]="component.video_autoplay_2"
                                                [background]="component.video_background_2" />
                            }
                        </div>
                        <!-- button -->
                        @if (component.button_label_2) {
                        <div class="pos-absolute bottom-2 left-3 z-4">
                            <button class="button-inline has-icon"
                                    type="button">
                                <span *iCms="'button_label_2' of component"></span>
                            </button>
                        </div>
                        }
                    </div>
                </href>
                }
                <!-- Gallery Image 3 -->
                <href [link]="component.link_3">
                    <div class="_ratio"
                         [ngClass]="[shareColumnsBottom(component), component.component_ratio]"
                         [style.height.%]="50">
                        <div class="rf overflow-hidden"
                             [ngClass]="[!client.isS ? component.padding === 'no_padding' ? '' : component.reverse === 'right' ? 'm-t-1' : ' m-l-1 m-t-1' : '']">
                            @if (component.video_id_3 && !component.image_3) {
                            <shell />
                            }
                            @if (component.image_3) {
                            <img class="z-2 animation-zoom-in animation-on-hover"
                                 [dfImage]="component.image_3"
                                 [ratio]="component.component_ratio"
                                 [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                                 [alt]="component.image_3.button_label_3"
                                 fill>
                            }
                            @if (component.video_id_3) {
                            <local-vimeo-player class="rf z-3 bg-col-w"
                                                [video-id]="component.video_id_3"
                                                [autoplay-in-viewport]="component.video_autoplay_3"
                                                [background]="component.video_background_3" />
                            }
                        </div>
                        <!-- button -->
                        @if (component.button_label_3) {
                        <div class="pos-absolute bottom-2 left-3 z-4">
                            <button class="button-inline has-icon"
                                    type="button">
                                <span *iCms="'button_label_3' of component"></span>
                            </button>
                        </div>
                        }
                    </div>
                </href>
                <!-- Gallery Image 4 -->
                @if (show4rdImg(component)) {
                <href [link]="component.link_4">
                    <div class="w-6 w-12-s _ratio"
                         [ngClass]="component.component_ratio"
                         [style.height.%]="50">
                        <div class="rf overflow-hidden"
                             [ngClass]="[!client.isS ? component.padding === 'no_padding' ? '' : component.reverse === 'right' ? ' m-l-1 m-t-1' : ' m-l-2 m-t-1' : '']">
                            @if (component.video_id_4 && !component.image_4) {
                            <shell />
                            }
                            @if (component.image_4) {
                            <img class="z-2 animation-zoom-in animation-on-hover"
                                 [dfImage]="component.image_4"
                                 [ratio]="component.component_ratio"
                                 [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                                 [alt]="component.image_4.button_label_4"
                                 fill>
                            }
                            @if (component.video_id_4) {
                            <local-vimeo-player class="rf z-3 bg-col-w"
                                                [video-id]="component.video_id_4"
                                                [autoplay-in-viewport]="component.video_autoplay_4"
                                                [background]="component.video_background_4" />
                            }
                        </div>

                        <!-- button -->
                        @if (component.button_label_4) {
                        <div class="pos-absolute bottom-2 left-3 z-4">
                            <button class="button-inline has-icon"
                                    type="button">
                                <span *iCms="'button_label_4' of component"></span>
                            </button>
                        </div>
                        }
                    </div>
                </href>
                }
            </div>
        </div>
    </div>
</div>